"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: "",
  components: {},
  props: {
    target: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {};
  },
  computed: {},
  watch: {},
  created: function created() {
    console.log("debug log --> ", this.target);
  },
  mounted: function mounted() {},
  methods: {}
};
exports.default = _default2;